// TODO: need to fix swag for generate enum
export enum PaymentToolDetailsType {
    BankCard = 'PaymentToolDetailsBankCard',
    Wallet = 'PaymentToolDetailsDigitalWallet',
    Terminal = 'PaymentToolDetailsPaymentTerminal',
    MobileCommerce = 'PaymentToolDetailsMobileCommerce',
}
